import * as types from './mutation-types'
import axios from 'axios'
import store from '../../store'

/**
 * Check whether the user is authenticated
 *
 * @param commit
 * @returns {Promise<any>}
 */
export const check = ({
  commit
}) => {
  return new Promise((resolve) => {
    commit(types.CHECK)
    resolve()
  })
}

/**
 * Login (acquire a token)
 *
 * @param commit
 * @param username
 * @param password
 * @returns {Promise<any>}
 */
export const login = async ({
  commit
}, {
  username,
  password
}) => {
  return new Promise(async (resolve, reject) => {
    // const params = new URLSearchParams()
    // params.append('domain', 'matcor-matsu')
    // params.append('username', username)
    // params.append('password', password)
    // params.append('grant_type', 'client_credentials')

    // axios.get('login/' + username + "/" + password)
    //   .then(resp => {
    //     commit(types.LOGIN, resp.data)
    //     store.dispatch('auth/role', {
    //       username
    //     }).then(() => {
    //       store.dispatch('auth/plants', {
    //         username
    //       }).then(() => {
    //         commit(types.LOGIN_PASSWORD, password)
    //         store.dispatch('auth/user', {
    //           username
    //         }).then(() => {
    //           resolve(resp.data)
    //         })
    //       })
    //     })
    //   })
    //   .catch(err => {
    //     reject(err.response.data);
    //   })

    // let formdata = new FormData()
    // formdata.set('Email', username)
    // formdata.set('Password', password)

    let data = {
      Email: username,
      Password: password,
    }
    // formdata.append('Email', username)
    // formdata.append('Password', password)

    // const response = await fetch(`http://localhost:55271/User/Login`, {
    //   method: 'POST',
    //   headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    //   // headers: {'content-type': 'multipart/form-data'},
    //   body: formdata,
    // })

    // console.log(response)
    try {
      const response = await axios({
        method: 'POST',
        url: process.env.VUE_APP_API_LOGIN,
        // url: 'http://localhost:55271/api/login',
        // url: 'https://boss40test.elabsinc.com/api/api/login',
        // url: 'https://demo.elabsinc.com/api/api/login',
        // url: 'https://securecom.elabsinc.com/api/api/login',
        data: data,
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded'
          // 'Content-Type': 'multipart/form-data'
        }
      })

      await commit(types.LOGIN, response.data)
      await commit(types.LOGIN_PASSWORD, password)


      const resUserInfo = await axios.get("api/user/getUserInfo")
      await commit(types.LOGIN_USER, resUserInfo.data)

      // console.log(resUserInfo.data)



      resolve(response.data)

    } catch (error) {

      reject(error.response.data);

    }

  })
}

export const role = ({
  commit
}, {
  username
}) => {
  return new Promise((resolve, reject) => {

    // alert(username)
    axios.get('users2roles/role_name/' + username)
      .then(resp => {
        commit(types.LOGIN_ROLE, resp.data[0])
        resolve(resp.data)
      })
      .catch(err => {
        reject(err.response.data);
      })
  })
}

export const plants = ({
  commit
}, {
  username
}) => {
  return new Promise((resolve, reject) => {

    // alert(username)
    axios.get('users2plants/' + username)
      .then(resp => {
        commit(types.LOGIN_PLANTS, resp.data)
        resolve(resp.data)
      })
      .catch(err => {
        reject(err.response.data);
      })
  })
}
export const user = ({
  commit
}, {
  username
}) => {
  return new Promise((resolve, reject) => {

    // alert(username)
    axios.get('login/user/' + username)
      .then(resp => {
        var user = resp.data
        if (typeof user === 'undefined' || user == null || user == "" || user == "error") {
          commit(types.LOGIN_USER, username)
          resolve(resp.data)
        } else {
          commit(types.LOGIN_USER, resp.data)
          resolve(resp.data)
        }
      })
      .catch(err => {
        reject(err.response.data);
      })
    // axios.get('login/user/' + username)
    //   .then(resp => {
    //     var user = resp.data
    //     if (typeof user === 'undefined' || user == null || user == "" || user == "error") {
    //       commit(types.LOGIN_USER, username)
    //       resolve(resp.data)
    //     } else {
    //       commit(types.LOGIN_USER, resp.data)
    //       resolve(resp.data)
    //     }
    //   })
    //   .catch(err => {
    //     reject(err.response.data);
    //   })
  })
}

/**
 * Logout
 *
 * @param commit
 * @returns {Promise<any>}
 */
export const logout = ({
  commit
}) => {
  return new Promise(resolve => {
    commit(types.LOGOUT)
    resolve()
  })
}

/**
 * Refresh the current token
 *
 * @param commit
 * @param state
 * @returns {Promise<any>}
 */
export const refresh = ({
  commit,
  state
}) => {
  return new Promise((resolve, reject) => {
    // const params = new URLSearchParams()
    // params.append('grant_type', 'refresh_token')
    // params.append('refresh_token', state.token.refreshToken)

    axios.get('api/token/refresh')
      .then(resp => {
        commit(types.LOGIN, resp.data)
        resolve(resp.data)
      })
      .catch(reject)
  })
}

/**
 * Change which lines appear for a user
 *
 * @param commit
 * @param state
 * @param lines
 * @returns {Promise<any>}
 */
export const changeLines = ({
  commit,
  state
}, lines) => {
  return new Promise((resolve, reject) => {
    axios.put(`line/${state.token.user.id}`, lines).then(() => {
      commit(types.CHANGE_LINES, lines)
      resolve()
    }).then((err) => {
      reject(err)
    })
  })
}

export const setNavMini = ({
  commit
}, {
  mini
}) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_NAV_MINI, mini)
    resolve()
  })
}

export const setSubMenu = ({
  commit
}, {
  subMenu
}) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_SUB_MENU, subMenu)
    resolve()
  })
}
export const setSubMenuDashboard = ({
  commit
}, {
  subMenu
}) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_SUB_MENU_DASHBOARD, subMenu)
    resolve()
  })
}

export const setClient = ({
  commit
}) => {
  return new Promise((resolve, reject) => {
    axios.get('api/clients/client').then(res => {
      var client = res.data.ClientName
      commit(types.SET_CLIENT, client)
      resolve()
    })
  })
}

export const setHasDashboards = ({
  commit
}) => {
  return new Promise((resolve, reject) => {
    var hasDashboards = false;
    var checkUserHasDashboards = axios
      .get("api/dashboards/checkUserHasDashboards")
      .then(res => {
        hasDashboards = res.data;
        commit(types.SET_HAS_DASHBOARDS, hasDashboards)
        resolve()
      })
      .catch(err => {
        hasDashboards = false;
        commit(types.SET_HAS_DASHBOARDS, hasDashboards)
        resolve()
      });
  })
}

export default {
  check,
  login,
  logout,
  refresh,
  changeLines,
  role,
  plants,
  user,
  setNavMini,
  setSubMenu,
  setSubMenuDashboard,
  setClient,
  setHasDashboards
}
